export type ContractValidationResult<T> =
  | { ok: true; value: T }
  | { ok: false; error: string };

export function valid<T>(value: T): ContractValidationResult<T> {
  return { ok: true, value };
}

export function invalid<T>(error: string): ContractValidationResult<T> {
  return { ok: false, error };
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isNullableString(value: unknown): value is string | null {
  return value === null || typeof value === 'string';
}

export function isSafeInteger(value: unknown): value is number {
  return typeof value === 'number' && Number.isSafeInteger(value);
}

export function isNullableSafeInteger(value: unknown): value is number | null {
  return value === null || isSafeInteger(value);
}

export function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}

export function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((item) => typeof item === 'string');
}

export function missingOr<T>(
  value: unknown,
  predicate: (candidate: unknown) => candidate is T,
): value is T | undefined {
  return value === undefined || predicate(value);
}
